import type { Component } from "solid-js";
import Dashboard from "./components/Dashboard";
import LegalPage from "./components/LegalPage";
import LoginPage from "./components/LoginPage";
import ManageBooking from "./components/ManageBooking";
import PublicBooking from "./components/PublicBooking";

const App: Component = () => {
  const path = window.location.pathname.replace(/^\/+|\/+$/g, "");
  const segments = path ? path.split("/") : [];

  if (segments[0] === "app") return <Dashboard />;
  if (segments[0] === "login" || segments.length === 0) return <LoginPage />;
  if (segments[0] === "booking" && segments[1]) {
    return <ManageBooking token={segments[1]} />;
  }
  if (segments[0] === "privacy") return <LegalPage kind="privacy" />;
  if (segments[0] === "terms") return <LegalPage kind="terms" />;
  if (segments.length === 2) {
    return <PublicBooking handle={segments[0]} slug={segments[1]} />;
  }
  return <LoginPage notFound />;
};

export default App;

